import { useState } from "react";

const channels = [
  {
    key: "wechat",
    label: "微信",
    icon: "ri-wechat-fill",
    tip: "打开微信「扫一扫」，或点击右上角分享到朋友圈，即可把本文分享给好友。",
  },
  {
    key: "weibo",
    label: "微博",
    icon: "ri-weibo-fill",
    tip: "点击分享后将跳转微博发布页，你可以补充观点后一键发布到你的微博主页。",
  },
  {
    key: "qq",
    label: "QQ",
    icon: "ri-qq-fill",
    tip: "点击分享后将唤起 QQ 会话选择窗口，选择好友或群聊即可发送本文链接。",
  },
];

export default function ShareBar({ title }: { title: string }) {
  const [openKey, setOpenKey] = useState<string | null>(null);
  const [copied, setCopied] = useState(false);
  const active = channels.find((c) => c.key === openKey);

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className="flex items-center gap-3 flex-wrap">
      <span className="text-sm text-foreground-500">分享到</span>
      {channels.map((ch) => (
        <button
          key={ch.key}
          type="button"
          onClick={() => setOpenKey(ch.key)}
          className="flex items-center gap-2 px-3.5 py-2 rounded-full bg-background-100 text-foreground-700 text-sm hover:bg-primary-50 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className={`${ch.icon} text-base`} />
          {ch.label}
        </button>
      ))}

      {active && (
        <div
          className="fixed inset-0 z-[60] flex items-center justify-center bg-black/40 px-4"
          onClick={() => setOpenKey(null)}
        >
          <div
            className="w-full max-w-sm rounded-xl bg-background-50 p-6 ht-fade-up"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-2">
                <i className={`${active.icon} text-xl text-primary-600`} />
                <h3 className="font-heading text-lg font-bold text-foreground-950">
                  分享到{active.label}
                </h3>
              </div>
              <button
                type="button"
                onClick={() => setOpenKey(null)}
                aria-label="关闭"
                className="w-8 h-8 flex items-center justify-center rounded-md text-foreground-500 hover:bg-background-100 cursor-pointer"
              >
                <i className="ri-close-line text-xl" />
              </button>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed mb-5">
              {active.tip}
            </p>
            <div className="rounded-lg bg-background-100 p-3 mb-5">
              <p className="text-xs text-foreground-400 mb-1">文章标题</p>
              <p className="text-sm text-foreground-800 line-clamp-2">{title}</p>
            </div>
            <button
              type="button"
              onClick={copyLink}
              className="w-full py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer"
            >
              {copied ? "链接已复制" : "复制文章链接"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}